import { useQuery } from "@tanstack/react-query";
import { hasCustomerId } from "@/lib/api";
import { fetchPurchasedProductDetail } from "@/lib/api";

export interface ShippingAddress {
  first_name: string;
  last_name: string;
  address1: string;
  address2: string | null;
  city: string;
  country: string;
  province: string;
  zip: string;
  phone: string | null;
}

export interface Customer {
  email: string;
  shipping_address: ShippingAddress | null;
}

export interface Variant {
  shopify_id: number;
  title: string;
  price: number;
  selected_options: Array<{
    name: string;
    value: string;
  }>;
}

export interface Option {
  id: string;
  name: string;
  values: string[];
  position: number;
}

export interface PurchasedProductDetail {
  id: number;
  variant_id: number;
  title: string;
  image_url: string;
  price: number;
  last_bought_at: string;
  is_favorite: boolean;
  favorite_id: number | null;
  shop_domain: string;
  product_sku: string;
  customer: Customer;
  variants: Variant[];
  options: Option[];
}

export function usePurchasedProductDetail(
  productId: number | null,
  enabled: boolean
) {
  return useQuery({
    queryKey: ["purchased-product-detail", productId],
    queryFn: async (): Promise<PurchasedProductDetail | null> => {
      if (!productId) return null;
      const result = await fetchPurchasedProductDetail(productId);
      return result as PurchasedProductDetail | null;
    },
    enabled: enabled && productId !== null && hasCustomerId(),
  });
}
